import { Goto } from "@/shared/navigation";

import { RobotoLinkHoverUnderline } from "../RobotoLinkHoverUnderline";

interface SessionLinkProps {
  /** ID of the session whose page the link opens. */
  sessionId: string;
}

/** Link to a session's page, labeled "Session se_…". */
export function SessionLink({ sessionId }: SessionLinkProps) {
  return (
    <RobotoLinkHoverUnderline
      to={Goto.createSessionRoute(sessionId)}
      variant="body2"
    >
      Session {sessionId}
    </RobotoLinkHoverUnderline>
  );
}
